import React from "react";
import classnames from "classnames";
import * as styles from "./index.module.scss";

export default function AvatarGroup({ className, ...rest }) {
  const classes = classnames(styles.root, className);

  return <div className={classes} {...rest} />;
}
